export default __webpack_public_path__ + "static/media/817.85c36fe6.gif";